<template>
  <IndexationTableWidget :is-read-only-mode="isReadOnlyMode" :currentIndexations="indexations"></IndexationTableWidget>
</template>
<script>
  export default {
    async created() {
      await this.$store.dispatch('indexationPlugin/loadAllIndexations');
      this.role = localStorage.getItem('role');
      if (this.role === 'Admin') {
        this.isReadOnlyMode = false;
      }
    },
    data() {
      return {
        isReadOnlyMode: true,
      };
    },
    computed: {
      indexations() {
        return this.$store.getters['indexationPlugin/getAllIndexations']
      }
    }
  }

</script>
